{
	"back": "กลับ",
	"backHome": "กลับไปยังหน้าหลัก",
	"brand": "บัตร VNGGames",
	"buyMore": "ซื้อเพิ่ม",
	"buyNow": "ซื้อเลย",
	"buyWith": "จ่ายด้วย",
	"cannotGetVoucherInfo": "ไม่สามารถดึงข้อมูลบัตรของคุณได้",
	"cardName": "ชื่อ",
	"cardPin": "PIN",
	"cards": "บัตร",
	"cardSerial": "หมายเลขซีรี่ย์",
	"checkAgain": "โปรดตรวจสอบอีกครั้ง",
	"checkEmail": "โปรดตรวจสอบอีเมลของคุณก่อนการสั่งซื้อ",
	"checkOrderStatusAgainHint1": "เรายังไม่ได้รับการชำระเงินสำหรับคำสั่งซื้อของคุณ",
	"checkOrderStatusAgainHint2": "โปรดตรวจสอบและยืนยันการชำระเงิน",
	"checkOrderStatusHint": "กำลังตรวจสอบการทำธุรกรรม โปรดรอสักครู่...",
	"checkout": "ชำระเงิน",
	"copied": "คัดลอก!",
	"copyright": "ลิขสิทธิ์ © 2023 VNG Corp. สงวนสิทธิ์ทั้งหมด",
	"date": "วันที่",
	"discount": "ส่วนลด",
	"discountNotIncluded": "(ไม่รวมส่วนลด)",
	"emptyCard": "ตะกร้าว่าง! โปรดเลือกสินค้าเพื่อดำเนินการต่อ",
	"emptyOrder": "ไม่มีอะไรที่นี่ กรุณาเลือกสินค้า",
	"emptyProductionText": "อุ๊ปส์! ขณะนี้ไม่มีสินค้าที่เหมาะกับคุณ",
	"endSlogan": "ยิ่งซื้อมาก ยิ่งได้ส่วนลดมากขึ้น",
	"errorPage": {
		"description": "เกิดข้อผิดพลาดที่ไม่คาดคิดเกิดขึ้นเราจึงไม่สามารถดำเนินการของคุณได้",
		"description2": "โปรดลองอีกครั้ง",
		"goBack": "กลับ",
		"title": "เกิดข้อผิดพลาดของเซิร์ฟเวอร์!"
	},
	"errors": {
		"common": "อุ๊ปส์ เกิดข้อผิดพลาดกรุณาลองอีกครั้งในภายหลัง"
	},
	"evoucherName": "ชื่อบัตร",
	"found": "พบแล้ว",
	"gameInMarket": "เกมที่รองรับการใช้บัตร VNGGames",
	"goBack": "ย้อนกลับ",
	"goBackInTime": "ย้อนกลับในอีก %{countdown} (วินาที)",
	"login": "เข้าสู่ระบบ",
	"loginHint": "โปรดเข้าสู่ระบบเพื่อดำเนินการต่อ",
	"logout": "ออกจากระบบ",
	"membershipCard": "บัตรสมาชิก",
	"name": "ชื่อ",
	"notFound": {
		"goToHome": "โปรดเปลี่ยนไปยังหน้าอื่นหรือไปที่หน้าหลัก",
		"pageNotExist": "ไม่พบหน้าที่คุณกำลังมองหา",
		"title": "ไม่พบหน้านี้!"
	},
	"notLoginHint": "คุณไม่ได้เข้าสู่ระบบ",
	"orderDate": "วันที่สั่งซื้อ",
	"orderId": "หมายเลขคำสั่งซื้อ",
	"orderMinLimitHint": "มูลค่าสั่งซื้อต่ำสุดต้องไม่น้อยกว่า",
	"orderMaxLimitHint": "มูลค่าสั่งซื้อต้องไม่มากกว่า",
	"paid": "ชำระเงินแล้ว",
	"paymentFailed": "<b>อุ๊ปส์! การชำระเงินล้มเหลว</b>",
	"paymentFailedHint": "การชำระเงินสำหรับหมายเลขคำสั่งซื้อ <b>%{orderId}</b> ไม่สามารถดำเนินการได้ <br/> โปรดลองอีกครั้ง",
	"paymentHint": "การคลิกที่ ซื้อเลย หมายถึงท่านยอมรับเงื่อนไขว่าธุรกรรมนี้ไม่สามารถขอคืนเงินหรือคืนสินค้าได้",
	"paymentMethod": "วิธีการชำระเงิน",
	"paymentStatus": "สถานะการชำระเงิน",
	"paymentSuccess": "ชำระเงินเสร็จสิ้น",
	"paymentSuccessHint": "รายละเอียดคำสั่งซื้อและการชำระเงินถูกส่งไปที่อีเมลของคุณ <b class='color-primary'>%{userEmail}</b>.",
	"pleaseCheck": "โปรดตรวจสอบ",
	"price": "ราคา",
	"purchaseHistory": "คำสั่งซื้อของฉัน",
	"myCards": "บัตรของฉัน",
	"quantity": "จำนวน",
	"redirectToPaymentProviderHint": "คุณกำลังถูกนำไปยังเว็บไซต์พันธมิตรของเราเพื่อดำเนินการชำระเงิน",
	"register": "ลงทะเบียน",
	"results": "ผลการค้นหา",
	"retryAgain": "ลองอีกครั้ง",
	"retryCheckOrder": "ฉันได้ชำระเงินแล้ว โปรดตรวจสอบอีกครั้ง",
	"seeDetailVoucherList": "ดูรายละเอียดของบัตรของคุณ",
	"sentCardToMail": "รายละเอียดคำสั่งซื้อและการชำระเงินจะถูกส่งไปยังอีเมลของคุณ",
	"showCards": "แสดงบัตร",
	"startSlogan": "ยิ่งซื้อมากเท่าไร",
	"status": "สถานะ",
	"subTotal": "ยอดรวม",
	"supportCenter": "ศูนย์บริการลูกค้า",
	"titleCardSelling": "เว็บไซต์ขายบัตรเกมของ VNGGames",
	"total": "ยอดรวม",
	"transactionId": "รหัสธุรกรรม:",
	"tryAgain": "โปรดลองอีกครั้ง",
	"yourOrder": "ตะกร้าของคุณ",
	"logoutLoadingHint": "ออกจากระบบ...",
	"loginLoadingHint": "เข้าสู่ระบบ...",
	"myProfile": "โปรไฟล์ของฉัน",
	"buyCards": "ซื้อบัตร",
	"termsOfSale": "ข้อกำหนดการขาย",
	"termsOfUse": "ข้อกำหนดการใช้งาน",
	"privacyPolicy": "นโยบายความเป็นส่วนตัว",
	"userGuide": {
		"title": "คู่มือผู้ใช้งาน",
		"chap1": "I. การ์ด ของ VNGGames",
		"viewProductsListTitle": "1. ดูรายการสินค้า",
		"registerTitle": "2. ลงทะเบียน",
		"loginTitle": "3. เข้าสู่ระบบ",
		"buyCardTitle": "4. ซื้อ การ์ด VNGGames",
		"orderHistoyTitle": "5. ประวัติการสั่งซื้อ",
		"cardManagementTitle": "6. การจัดการ บัตร",
		"chap2": "II. แลกที่ ร้าน VNGGames",
		"accessVGC": "ขั้นตอนที่ 1: เข้าถึง การ์ด VNGGames",
		"clickBuyNow": "ขั้นตอนที่ 2: คลิกปุ่ม 'ซื้อเลย' หรือซื้อการ์ด",
		"clickUserIconStep1": "ขั้นตอนที่ 1: คลิกไอคอนผู้ใช้",
		"clickUserIconStep2": "ขั้นตอนที่ 2: คลิกไอคอนผู้ใช้",
		"clickCreateAccount": "ขั้นตอนที่ 2: คลิก 'สร้างบัญชี VNGGames ' เพื่อสร้าง บัญชี VNGGames",
		"step3": "ขั้นตอนที่ 3:",
		"step3EnterRegisteredEmail": "ป้อนอีเมลที่ยังไม่เคยใช้เพื่อลงทะเบียนบน การ์ด VNGGames",
		"step3AgreePrivacyPolicy": "เลือก \"ฉันยินยอมตาม นโยบายความเป็นส่วนตัว\"",
		"step3ClickContinue": "คลิกปุ่มดำเนินการต่อ",
		"note": "บันทึก:",
		"clickToReadPrivacyPolicy": "ผู้ใช้สามารถคลิก \"นโยบายความเป็นส่วนตัว\" เพื่ออ่านข้อมูลก่อนที่จะเลือก \"ฉันยินยอมตาม นโยบายความเป็นส่วนตัว\"",
		"displayExistedEmail": "หากผู้ใช้ใช้อีเมลที่มีอยู่แล้ว หลังจากคลิกปุ่ม 'เล่นต่อ' ข้อความ \"มีอีเมลอยู่\" จะปรากฏขึ้น ",
		"enterValidPasswordRegister": "ขั้นตอนที่ 4: ป้อนรหัสผ่านที่ถูกต้องแล้วคลิกปุ่ม 'เล่นต่อ'",
		"enterActivationCode": "ขั้นตอนที่ 5: ป้อนรหัสเปิดใช้งานที่ส่งไปยังอีเมลของคุณและคลิกปุ่ม 'เล่นต่อ'",
		"activationCodeTimeout": "รหัสเปิดใช้งานมีอายุเพียง 60 วินาทีเท่านั้น",
		"resendActivationCode": "หากคุณไม่ได้รับรหัสยืนยัน หรือรหัสหมดอายุ คุณสามารถคลิก ' ส่งรหัสอีกครั้ง'",
		"enterPersonalInfo": "ขั้นตอนที่ 6: ป้อนข้อมูลส่วนตัวของคุณในแบบฟอร์มต่อไปนี้ และคลิกปุ่ม 'เล่นต่อ'",
		"completeRegistration": "ขั้นตอนที่ 7: คลิกปุ่ม 'เล่นต่อ' เพื่อสร้าง บัญชี VNGGames ของคุณ และเข้าถึง การ์ด VNGGames",
		"redirectToBuyCard": "ขั้นตอนที่ 8: หลังจากสร้าง บัญชี VNGGames สำเร็จ แล้ว ผู้ใช้จะถูกเปลี่ยนเส้นทางไปยังหน้าซื้อการ์ด",
		"enterRegisteredEmail": "ขั้นตอนที่ 3: ป้อนอีเมลที่ลงทะเบียนแล้วคลิกปุ่ม 'เล่นต่อ'",
		"enterValidPasswordLogin": "ขั้นตอนที่ 4: ป้อนรหัสผ่านที่ถูกต้องแล้วคลิกปุ่ม 'เล่นต่อ' ผู้ใช้จะถูกเปลี่ยนเส้นทางไปยังหน้าซื้อการ์ด",
		"retypeEmail": "หากผู้ใช้ต้องการป้อนอีเมลอีกครั้ง ก็สามารถคลิกปุ่ม 'ป้อนอีเมลอีกครั้ง'",
		"recoverPassword": "หากผู้ใช้จำรหัสผ่านไม่ได้ ก็สามารถคลิก 'กู้คืนรหัสผ่าน' เพื่อเรียกคืน ได้",
		"selectMarket": "ขั้นตอนที่ 1: เลือกตลาดที่ผู้ใช้ต้องการซื้อการ์ด",
		"selectQuantity": "ขั้นตอนที่ 2: เลือกจำนวนการ์ดที่คุณต้องการซื้อ",
		"cardLimitation": "ผู้ใช้สามารถเลือกการ์ดได้หลายใบ โดยมีจำนวนการ์ดสูงสุด 99 ใบต่อประเภท ภายในค่าจำกัดที่อนุญาต",
		"limitationRangeHighlight": "หากมูลค่าการสั่งซื้อน้อยกว่าหรือมากกว่าขีดจำกัดของมูลค่าที่อนุญาต การแจ้งเตือนขีดจำกัดขั้นต่ำ/สูงสุดจะถูกเน้นด้วยสีแดงและซื้อทันทีจะถูกปิดใช้งาน",
		"verifyCart": "ขั้นตอนที่ 3: ยืนยันรถเข็นของคุณ เลือกวิธีการชำระเงิน และคลิกปุ่ม 'ซื้อเลย' เพื่อดำเนินการชำระเงิน",
		"readTermsOfSale": "ก่อนกดปุ่มซื้อทันที คุณควรอ่านเงื่อนไขการขายของเราโดยคลิกที่ 'ข้อกำหนดการขาย'",
		"partnerWebsite": "ขั้นตอนที่ 4: ดำเนินการชำระเงินบนเว็บไซต์ของพันธมิตร",
		"viewTransactionDetailsBuyCard": "ขั้นตอนที่ 5: ดูผลการทำธุรกรรมหรือคลิกที่ดูรายละเอียดบัตรของคุณ",
		"clickBuyMore": "คลิกปุ่มซื้อเพิ่มเติมเพื่อซื้อการ์ดต่อ",
		"clickBackToHome": "คลิก 'กลับไปยังหน้าหลัก' เพื่อกลับสู่หน้าแรก",
		"checkOrderAndPayment": "ขั้นตอนที่ 6: ผู้ใช้สามารถตรวจสอบการสั่งซื้อและข้อมูลการชำระเงิน บัตร VNGGames โดย:",
		"checkOrderAndPaymentMethod1": "วิธีที่ 1: ตรวจสอบอีเมลที่ได้รับหลังจากซื้อบัตรสำเร็จแล้วคลิกหน้าคำสั่งซื้อภายในเนื้อหาอีเมล",
		"goToOrderPage": "เมื่อคุณคลิกที่หน้าการสั่งซื้อ คุณจะถูกนำไปยังหน้าผลการชำระเงิน และคุณต้องเข้าสู่ระบบด้วยบัญชี บัตร VNGGames ที่ถูกต้องที่คุณใช้ในการซื้อบัตร ก่อนหน้านี้",
		"checkOrderAndPaymentMethod2": "วิธีที่ 2: ไปที่หน้าคำสั่งซื้อของฉันและตรวจสอบ ในส่วนที่ 5 .ประวัติการสั่งซื้อ",
		"checkOrderAndPaymentMethod3": "วิธีที่ 3: ไปที่หน้า 'บัตรของฉัน' และตรวจสอบในหัวข้อ 6. การจัดการ บัตร",
		"clickMyOrders": "ขั้นตอนที่ 1: คลิกปุ่ม 'คำสั่งซื้อของฉัน'",
		"viewOrderHistory": "ขั้นตอนที่ 2: ดูประวัติการสั่งซื้อ",
		"orderHistoryFilter": "ผู้ใช้สามารถกรองประวัติการสั่งซื้อตามวันที่ สถานะ และวิธีการชำระเงิน",
		"clickOrderId": "ผู้ใช้สามารถคลิก ' หมายเลขคำสั่งซื้อ' เพื่อดูรายละเอียด",
		"clickMyCardButton": "ขั้นตอนที่ 1: คลิกปุ่ม 'บัตรของฉัน'",
		"enterVerifyOTP": "ขั้นตอนที่ 2: ป้อนรหัสเปิดใช้งานที่ส่งไปยังอีเมลของคุณและคลิกปุ่ม 'ตรวจสอบ'",
		"myCardOTPTimeout": "OTP เปิดใช้งานจะใช้ได้เพียง 5 นาทีเท่านั้น",
		"resendOTP": "หากคุณไม่ได้รับ OTP ยืนยัน หรือ OTP หมดอายุ คุณสามารถคลิก 'ส่ง OTP อีกครั้ง'",
		"durationBetween2OTP": "เวลาระหว่างการส่ง OTP แต่ละครั้งคือ 60 วินาที",
		"wrong3TimesARow": "หากคุณป้อน OTP ผิดเกิน 3 ครั้งติดต่อกันภายใน 2 ชั่วโมง การตรวจสอบ OTP ของคุณจะถูกล็อคเป็นเวลา 10 นาที",
		"remainingResend": "หากการยืนยัน OTP ของคุณถูกล็อคเป็นเวลา 10 นาที แต่คุณยังคงสามารถส่ง OTP ใหม่ได้ หลังจากคลิกส่ง OTP ใหม่ คุณจะยังคงสามารถป้อน OTP ใหม่ได้",
		"resendOtp2TimeInHour": "หากคุณขอส่ง OTP มากกว่า 3 ครั้งภายใน 2 ชั่วโมง ระบบจะล็อคฟังก์ชัน Resend OTP ของคุณเป็นเวลา 15 นาที",
		"redirectToMyCards": "หลังจากตรวจสอบ OTP สำเร็จแล้ว ผู้ใช้จะถูกเปลี่ยนเส้นทางไปยังหน้ารายละเอียดบัตรของฉัน",
		"userCanSearchCardBy": "ขั้นตอนที่ 3: ผู้ใช้สามารถค้นหาการ์ดโดย:",
		"enterInputField": "ป้อนรหัสคำสั่งซื้อหรือชื่อบัตรในช่องรหัสคำสั่งซื้อ/ชื่อบัตร",
		"clickPurchaseDate": "คลิกที่ฟิลด์วันที่ซื้อ:",
		"selectFromToDate": "เลือกจากวันที่ - ถึงวันที่",
		"selectLastWeek": "เลือกสัปดาห์ที่แล้ว",
		"selectLastMonth": "เลือกเดือนที่แล้ว",
		"select3Months": "อก 3 เดือน",
		"clickCardStatus": "คลิกที่ฟิลด์สถานะบัตร:",
		"selectAll": "เลือกทั้งหมด",
		"selectSold": "เลือกขายแล้ว",
		"selectAvailable": "เลือกที่มี",
		"selectCardsToAction": "ขั้นตอนที่ 4: เลือกบัตรแต่ละใบหรือเลือกบัตรทั้งหมด จากนั้นคลิกที่ทำเครื่องหมายว่าขายแล้ว/คัดลอก/อีเมล/ส่งออก",
		"markAsSold": "ทำเครื่องหมายว่าขายแล้ว: หลังจากขายการ์ดแล้ว คุณสามารถทำเครื่องหมายว่าขายแล้ว",
		"copyCard": "คัดลอก: ใช้เพื่อคัดลอกข้อมูลของการ์ดที่เลือก",
		"exportCard": "ส่งออก: ใช้เพื่อส่งออกการ์ดที่เลือกเป็นไฟล์ PDF",
		"emailCard": "อีเมล: ใช้เพื่อส่งข้อมูลของการ์ดที่เลือกทางอีเมล",
		"sendToMe": "ผู้ใช้สามารถส่งอีเมลถึงตนเองโดยเลือก \"ส่งไปยังอีเมลของฉัน\" จากนั้นคลิกปุ่ม \"ส่งอีเมล\"",
		"sentToOther": "ผู้ใช้สามารถส่งอีเมลถึงบุคคลอื่นโดยเลือก \"ส่งไปยังอีเมลอื่น\" ป้อนที่อยู่อีเมลของผู้รับในช่อง \"อีเมลผู้รับ\" แล้วคลิกปุ่ม \"ส่งอีเมล\"",
		"markAsSoldEmail": "ผู้ใช้สามารถคลิกที่ \"ทำเครื่องหมายทุกบัตรว่าขายแล้ว\" เพื่อทำเครื่องหมายบัตรเป็นขายหลังจากส่ง",
		"emailSendLimitation": "ผู้ใช้สามารถส่งอีเมลได้สูงสุด 10 ฉบับภายในระยะเวลา 24 ชั่วโมง หลังจาก 24 ชั่วโมง ขีดจำกัดการส่งอีเมลจะถูกรีเซ็ต",
		"clickEmailHistoryToView": "ขั้นตอนที่ 5: คลิกที่ \"ประวัติอีเมล\" เพื่อตรวจสอบอีเมลที่ส่งไปก่อนหน้านี้ค่ะ",
		"processRedeem": "หลังจากที่ผู้ใช้ซื้อการ์ดบน VNGGames Card สำเร็จแล้ว ผู้ใช้สามารถดำเนินการแลกได้ที่ ร้านค้า VNGGames",
		"accessVNGGamesShopAndLogin": "ขั้นตอนที่ 1: เข้า เกมร้าน VNGGames และเข้าสู่ระบบ",
		"indonesia": "อินโดนีเซีย",
		"philiphines": "ฟิลิปปินส์",
		"thailand": "ไทย",
		"malaysia": "มาเลเซีย",
		"singapore": "สิงคโปร์",
		"marketLimitation": "การ์ดที่ซื้อในตลาดใด ๆ จะถูกนำไปใช้กับ ร้าน VNGGames ของตลาดนั้น อย่างถูกต้อง",
		"selectVGCMethod": "ขั้นตอนที่ 2: เลือก วิธีการใช้การ์ด VNGGames",
		"selectSuitablePackage": "ขั้นตอนที่ 3: เลือกแพ็คเกจที่มีราคาคงที่ซึ่งตรงกับมูลค่าของการ์ดที่ซื้อบน VNGGames Card",
		"inputSerialAndPIN": "ขั้นตอนที่ 4: ป้อนหมายเลขซีเรียล + PIN ที่ถูกต้อง",
		"clickRedeemButton": "ขั้นตอนที่ 5: คลิกปุ่ม ' ไถ่ถอน'",
		"viewTransactionAndCheckInGame": "ขั้นตอนที่ 6: ดูผลการทำธุรกรรมและตรวจสอบในเกม",
		"lastModified": "แก้ไขล่าสุด: 24 กรกฎาคม 2023"






	},
	"faq": {
		"title": "คำถามที่พบบ่อย",
		"whatIsVNGGamesCard": "การ์ด VNGGames คืออะไร?",
		"benefits": "ประโยชน์ของการชำระค่าเกมด้วย บัตร VNGGames",
		"whereToPurchase": "ฉันจะซื้อ การ์ด VNGGames ได้ที่ไหน",
		"howToRedeem": "จะเติมเกมด้วย VNGGames Card ได้อย่างไร?",
		"errorWhenRedeem": "เกิดข้อผิดพลาดเมื่อเติมเกมด้วย การ์ด VNGGames",
		"errorWhenPurchaseViaBank": "เกิดข้อผิดพลาดเมื่อซื้อ บัตร VNGGames ผ่านธนาคาร",
		"errorWhenPurchaseViaEWallet": "เกิดข้อผิดพลาดในการชำระเงินด้วย E-wallet"
	},
	"regionLockedProductHint": "บัตร VNGGames เป็นผลิตภัณฑ์ที่ล็อคเขตพื้นที่ การซื้อทุกครั้งไม่สามารถคืนเงินหรือคืนสินค้าได้",
	"chooseMarket": "เลือกตลาดของคุณ",
	"successful": "สำเร็จ",
	"failed": "ไม่สำเร็จ",
	"andMore": "และอื่นๆ",
	"tosAgreementHint": "เมื่อคลิกซื้อเลย นั่นหมายถึงท่านยอมรับในข้อตกลง",
	"all": "ทั้งหมด",
	"duration": {
		"oneWeek": "1 สัปดาห์ก่อน",
		"oneMonth": "1 เดือนก่อน",
		"threeMonths": "3 เดือนก่อน"
	},
	"selectPaymentMethodHint": "เลือกวิธีการชำระเงินของคุณ",
	"selectLanguageHint": "เลือกภาษาของคุณ",
	"links": "ลิงก์",
	"generatingCardHint": "กำลังสร้างบัตร โปรดรอสักครู่...",
	"sessionTimeout": "เซสชั่นของคุณหมดเวลาแล้ว กรุณาเข้าสู่ระบบอีกครั้ง",
	"copy": "คัดลอก",
	"menu": "เมนู",
	"searchInputPlaceholder": "ค้นหาตามรหัสคำสั่งซื้อ / ชื่อบัตร",
	"cardValue": "มูลค่าบัตร",
	"cardSelected": "เลือกบัตร %{totalCardSelected} ใบ",
	"markAsSold": "ทำเครื่องหมาย %{totalCardSelected} เป็นขายแล้ว",
	"markAsSoldShort": "ทำเครื่องหมายว่าขายแล้ว",
	"email": "อีเมล",
	"export": "ส่งออก",
	"to": "ถึง",
	"startDate": "วันที่เริ่มต้น",
	"endDate": "วันที่สิ้นสุด",
	"lastWeek": "สัปดาห์ที่แล้ว",
	"lastMonth": "เดือนที่แล้ว",
	"last3Months": "3 เดือนที่แล้ว",
	"purchased": "ซื้อแล้ว",
	"purchasedDate": "วันที่ซื้อ",
	"orderIdOrCardName": "เลขที่ใบสั่งซื้อ / ชื่อบัตร",
	"typeToSearch": "พิมพ์เพื่อค้นหา",
	"cardsCopiedSucessfully": "คัดลอกบัตรสำเร็จแล้ว!",
	"expires": "วันหมดอายุ",
	"sold": "ขายแล้ว",
	"validUntil": "ใช้ได้ถึงวันที่",
	"available": "สามารถใช้ได้",
	"homepage": "หน้าหลัก",
	"error": "เกิดข้อผิดพลาด",
	"verifyOtp": {
		"title": "ตรวจสอบอีเมลของคุณ",
		"emailHint": "รหัสผ่านใช้ครั้งเดียว (OTP) ถูกส่งไปยังที่อยู่อีเมลแล้ว",
		"label": "รหัสผ่านใช้ครั้งเดียว",
		"buttonVerify": "ตรวจสอบ",
		"resendOtp": "ส่ง OTP อีกครั้ง",
		"required": "โปรดกรอกข้อมูลในฟิลด์นี้",
		"invalid": "OTP ไม่ถูกต้องหรือหมดอายุแล้ว",
		"requestLimited": "จำนวนครั้งในการขอ OTP เกินกว่าที่กำหนดไว้ บัญชีถูกล็อคชั่วคราว",
		"validateLimited": "จำนวนครั้งในการยืนยัน OTP เกินกว่าที่กำหนดไว้ บัญชีถูกล็อคชั่วคราว",
		"resendHint": "เราได้ส่งรหัส OTP ใหม่ไปยังที่อยู่อีเมลของคุณ"
	},
	"cardInventory": {
		"markAsSoldHint": "กรุณาเลือกบัตรอย่างน้อยหนึ่งใบ!",
		"markAsSoldSuccess": "ทำเครื่องหมายว่าขายเรียบร้อยแล้ว!",
		"twoFactorExpired": "กรุณายืนยันตัวตนของคุณเนื่องจากเซสชั่นของคุณหมดอายุแล้ว",
		"copyCardHint": "กรุณาเลือกบัตรอย่างน้อยหนึ่งใบ!",
		"copyCardSuccess": "คัดลอกข้อมูลบัตรเสร็จสิ้น!",
		"sendEmailHint": "กรุณาเลือกบัตรอย่างน้อยหนึ่งใบ!",
		"exportFileHint": "กรุณาเลือกบัตรอย่างน้อยหนึ่งใบ!",
		"exportFileSuccess": "ส่งออกไฟล์เรียบร้อยแล้ว! โปรดตรวจสอบโฟลเดอร์ดาวน์โหลดของคุณ",
		"sendEmailTitle": "ส่งอีเมล",
		"sendToMyEmail": "ส่งไปยังอีเมลของฉัน (%{userEmail})",
		"sendToOther": "ส่งไปยังอีเมลอื่น",
		"receiverEmail": "อีเมลผู้รับ",
		"markAllAsSold": "ทำเครื่องหมายทุกบัตรว่าขายแล้ว",
		"sendEmailButton": "ส่งอีเมล",
		"sendMailSuccess": "ส่งอีเมล์สำเร็จแล้ว!",
		"errorIsRequired": "โปรดกรอกข้อมูลในฟิลด์นี้",
		"errorInvalidFormat": "รูปแบบอีเมลไม่ถูกต้อง",
		"cardStatusText": "สถานะบัตร",
		"emailHistory": {
			"title": "ประวัติอีเมล",
			"receiverEmail": "อีเมลผู้รับ",
			"sendingTime": "เวลาที่ส่ง",
			"emailStatus": "สถานะอีเมล",
			"successful": "สำเร็จ",
			"sending": "กำลังส่ง",
			"failed": "ไม่สำเร็จ",
			"cardInformation": " ข้อมูลบัตร",
			"emailLimitHint": "คุณมี %{currentEmailAvailable} ครั้งในการส่งอีเมล",
			"until": "จนกระทั่ง",
			"overLimit": "คุณได้ส่งเกินจำนวนที่กำหนดแล้ว",
			"pleaseWait": "กรุณารอจนกว่า"


		}
	},
	"pagination": {
		"total": "ทั้งหมด",
		"pageSize": "/เลือก",
		"goTo": "ไปที่"

	},
	"changeDomainToast": {
		"part1": "ที่อยู่เว็บไซต์ใหม่",
		"part2": "shop.vnggames.com/card",
		"part3": "จะเปลี่ยนแปลงตั้งแต่วันที่ 15 มกราคม 2024"
	}
}
